function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7719AA",
  d: "M3.333325,0 L36.666725,0 C38.5076541,0 40,1.49242092 40,3.33335 L40,36.66665 C40,38.507575 38.507675,40 36.66675,40 L3.33335,40 C1.49239163,40 0,38.5076084 0,36.66665 L0,3.333325 C0,1.49238044 1.49238044,0 3.333325,0 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10,6.66666667 L14.881909,6.66666667 L23.2643331,23.4957417 C23.7010551,24.2216417 24.0285927,24.8056083 24.246946,25.2476417 L24.309325,25.2476417 C24.1915906,24.1470126 24.1446859,23.0387429 24.168955,21.9309667 L24.168955,6.66666667 L28.3333333,6.66666667 L28.3333333,31.6666667 L23.7633653,31.6666667 L15.0222102,15.0934917 C14.6858908,14.5465958 14.3886687,13.9722831 14.1331774,13.3756417 L14.0552322,13.3756417 C14.1563019,14.5856229 14.1979474,15.8006337 14.1799903,17.0154667 L14.1799903,31.6666667 L10,31.6666667 L10,6.66666667 Z"
}));

var SvgOnenoteIco = function SvgOnenoteIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnenoteIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onenote_ico.4b486fa7.svg";
export { ForwardRef as ReactComponent };